import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import Button from "../../Components/Button"
import API from "../../Common/API"
import { useDispatch, useSelector } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import verification from '../../Assets/Images/storeVerfication.png'
import { useTranslation } from "react-i18next"
import FieldSelect from "../../Components/FieldSelect"

const initialSellerForm = {
    firmRegistrationType: '',
    bankDetails: {
        accountNo: '',
        accountName: '',
        ifscCode: '',
        branchName: ''
    },
    panCardNo: '',
    accountName: '',
    mobileNumber: '',
    accountAddress: {
        addressLine1: '',
        addressLine2: '',
        state: '',
        district: '',
        landMark: '',
        city: '',
        pinCode: ''
    },
    businessProof: '',
    rkId: '',
}
const firmTypes = [{ text: 'Sole Proprietorship', value: 'soleProprietorship' }, { text: 'Private Limited (PVT LTD)', value: 'privateLimited' }, { text: 'Public Limited (PLC)', value: 'publicLimited' }]

const CreateSellerAccount = () => {

    const userDetails = useSelector((state) => state.auth.userDetails)
    const [loading, setLoading] = useState(true)
    const [alreadyRegister, setAlreadyRegister] = useState()
    const [imageSrc, setImageSrc] = useState()
    const [count, setCount] = useState(0)
    const dispatch = useDispatch()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const { t } = useTranslation()
    const [addressEdit, setAddressEdit] = useState(false)

    const sellerFormSchema = Yup.object().shape({
        // accountName: Yup.string().required("Account name is required"),
        // accountAddress: Yup.object().shape({
        //     addressLine1: Yup.string().required("Address line 1 is required"),
        //     addressLine2: Yup.string().nullable(),
        //     state: Yup.string().required("State is required"),
        //     district: Yup.string().required("District is required"),
        //     city: Yup.string().required("City/Town is required"),
        //     pinCode: Yup.string().required("Pincode is required"),
        //     landMark: Yup.string().nullable()
        // }),
        // businessProof: Yup.string().required("BusinessProof is required"),
        firmRegistrationType: Yup.string().required("Firm Registration type is required"),
        bankDetails: Yup.object().shape({
            accountNo: Yup.string().required("Account Number is required"),
            accountName: Yup.string().required("Account Name is required"),
            ifscCode: Yup.string().required("IFSC Code is required"),
            branchName: Yup.string().required("Branch Name is required")
        }),
        panCardNo: Yup.string().required("Pan Card Number is required"),
        accountName: Yup.string().required("Account name is required"),
        mobileNumber: Yup.string().required("Mobile Number is required"),
        accountAddress: Yup.object().shape({
            addressLine1: Yup.string().required("Address Line1 is required"),
            addressLine2: Yup.string().nullable(),
            state: Yup.string().required("State is required"),
            district: Yup.string().required("District is required"),
            landMark: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            pinCode: Yup.string().required("Pincode is required")
        }),
        businessProof: Yup.string().nullable(),
        rkId: Yup.string().required("RK Id is required")
    })


    const sellerForm = useFormik({
        initialValues: initialSellerForm,
        validateOnMount: true,
        validationSchema: sellerFormSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm, setSubmitting }) => {
            setSubmitDisabled(true)
            // values.businessProof = imageSrc
            if (!imageSrc) {
                dispatch(setAlert({ title: 'Error', subtitle: 'Please upload your business proof', active: true, type: 'error' }))
                setSubmitDisabled(false);
                return;
            } else {
                values.businessProof = imageSrc
            }
            values.userId = userDetails.subject._id
            API.post('/accounts/createSellerAccount', values).then((sellerRes) => {
                if (sellerRes.status === 200) {
                    resetForm()
                    dispatch(setAlert({ title: 'Success', subtitle: 'Seller Account Created Successfully', active: true, type: 'success' }))
                    setCount(count + 1)
                    setSubmitDisabled(false)
                }
            })
        }
    })

    useEffect(() => {
        setLoading(true)
        API.get(`/accounts/sellerAccount/${userDetails.subject._id}`).then((sellerRes) => {
            if (sellerRes.status === 200) {
                setAlreadyRegister(sellerRes.data.data)
                setLoading(false)
            }
        })
    }, [count])// eslint-disable-line

    const uploadFile = (event) => {
        const file = event.target.files[0];

        if (!file) {
            console.error("No file selected");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            // Here you get the base64 string from the image
            setImageSrc(reader.result);  // assuming `setImageSrc` updates your state
        };
        reader.readAsDataURL(file); // This must be a valid File/Blob
    };
    const getLocation = (value) => {
        if (value.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${value}`).then((pinRes) => {
                if (pinRes.status === 200) {
                    const location = pinRes.data.data
                    sellerForm.setValues({ ...sellerForm.values, accountAddress: { city: location?.city || '', district: location?.district || '', pinCode: location?.pinCode || '', state: location?.state || '' } })
                    setAddressEdit(true)
                }
            })
        } else if (value.length === 0) {
            sellerForm.setValues({ ...sellerForm.values, accountAddress: { city: '', district: '', pinCode: '', state: '', addressLine1: '', addressLine2: '' } })
            setAddressEdit(false)
        }
    }

    return (
        <>
            {
                loading ? t('Loading...') : alreadyRegister === null || alreadyRegister.status === 'Reject' ? <motion.div className="h-[80vh] overflow-auto relative bg-white  w-full items-center flex flex-col justify-center">
                    <motion.div className="text-black font-bold text-xl">
                        {t('Create a seller account')}
                    </motion.div>
                    {/* <motion.div className="my-5 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
                        <FieldInput label={t("Account/Business Name")} placeholder={t('Account/Business Name')} fieldProps={sellerForm.getFieldProps('accountName')} fieldHelper={sellerForm.getFieldHelpers('accountName')} fieldMeta={sellerForm.getFieldMeta('accountName')} edit={true} dataLoaded={true} />
                        <FieldInput label="RKID" placeholder={'RKID'} fieldProps={sellerForm.getFieldProps('rkId')} fieldHelper={sellerForm.getFieldHelpers('rkId')} fieldMeta={sellerForm.getFieldMeta('rkId')} edit={true} dataLoaded={true} />
                        <FieldInput label={t("Pincode")} placeholder={t('Pincode')} fieldProps={sellerForm.getFieldProps('accountAddress.pinCode')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.pinCode')} fieldMeta={sellerForm.getFieldMeta('accountAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                        <FieldInput label={t("Address Line 1")} placeholder={t('Address Line 1')} fieldProps={sellerForm.getFieldProps('accountAddress.addressLine1')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.addressLine1')} fieldMeta={sellerForm.getFieldMeta('accountAddress.addressLine1')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={t("Address Line 2")} placeholder={t('Address Line 2 (Optional)')} fieldProps={sellerForm.getFieldProps('accountAddress.addressLine2')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.addressLine2')} fieldMeta={sellerForm.getFieldMeta('accountAddress.addressLine2')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={t("City/Town")} placeholder={t('City/Town')} fieldProps={sellerForm.getFieldProps('accountAddress.city')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.city')} fieldMeta={sellerForm.getFieldMeta('accountAddress.city')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={t("District")} placeholder={t('District')} fieldProps={sellerForm.getFieldProps('accountAddress.district')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.district')} fieldMeta={sellerForm.getFieldMeta('accountAddress.district')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={t("Landmark")} placeholder={t('Landmark')} fieldProps={sellerForm.getFieldProps('accountAddress.landMark')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.landMark')} fieldMeta={sellerForm.getFieldMeta('accountAddress.landMark')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={t("State")} placeholder={t('State')} fieldProps={sellerForm.getFieldProps('accountAddress.state')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.state')} fieldMeta={sellerForm.getFieldMeta('accountAddress.state')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={t("Business Proof")} type="file" fieldProps={sellerForm.getFieldProps('businessProof')} fieldHelper={sellerForm.getFieldHelpers('businessProof')} fieldMeta={sellerForm.getFieldMeta('businessProof')} edit={addressEdit} dataLoaded={true} onChange={(ev) => uploadFile(ev)} />
                    </motion.div> */}
                    <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1">
                        <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                            <FieldInput label={'Firm Name'} placeholder={'Firm Name'} fieldProps={sellerForm.getFieldProps('accountName')} fieldHelper={sellerForm.getFieldHelpers('accountName')} fieldMeta={sellerForm.getFieldMeta('accountName')} edit={true} dataLoaded={true} />
                            <FieldInput label="RKID" placeholder={'RKID'} fieldProps={sellerForm.getFieldProps('rkId')} fieldHelper={sellerForm.getFieldHelpers('rkId')} fieldMeta={sellerForm.getFieldMeta('rkId')} edit={true} dataLoaded={true} />
                            <FieldSelect label={'Firm Registration Type'} placeholder={'Firm Registration Type'} fieldProps={sellerForm.getFieldProps('firmRegistrationType')} fieldHelper={sellerForm.getFieldHelpers('firmRegistrationType')} fieldMeta={sellerForm.getFieldMeta('firmRegistrationType')} edit={true} dataLoaded={true} options={firmTypes} />
                            <FieldInput label={'PAN Card No'} placeholder={'PAN Card no'} fieldProps={sellerForm.getFieldProps('panCardNo')} fieldHelper={sellerForm.getFieldHelpers('panCardNo')} fieldMeta={sellerForm.getFieldMeta('panCardNo')} edit={true} dataLoaded={true} />
                            {/* <FieldInput type="file" label={'Business Proof'} placeholder={'Business Proof'} fieldProps={sellerForm.getFieldProps('businessProof')} fieldHelper={sellerForm.getFieldHelpers('businessProof')} fieldMeta={sellerForm.getFieldMeta('businessProof')} edit={true} dataLoaded={true} onChange={(file) => uploadFile(file)} /> */}
                            <motion.div className="flex px-5 flex-col w-full">
                                <label>Business Proof</label>
                                <input className="px-2 py-2 ring-1 my-1 rounded-md ring-[lightGrey]" type="file" onChange={uploadFile} />
                            </motion.div>
                            <FieldInput type="phone" label={'Firm Mobile Number'} placeholder={'Firm MobileNumber'} fieldProps={sellerForm.getFieldProps('mobileNumber')} fieldHelper={sellerForm.getFieldHelpers('mobileNumber')} fieldMeta={sellerForm.getFieldMeta('mobileNumber')} edit={true} dataLoaded={true} />
                        </motion.div>
                        <motion.div className='flex w-full my-2  px-5'>
                            <p className='font-bold text-xl'>Bank Details</p>
                            <div></div>
                        </motion.div>
                        <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                            <FieldInput label={'Account Name'} placeholder={'Account Name'} fieldProps={sellerForm.getFieldProps('bankDetails.accountName')} fieldHelper={sellerForm.getFieldHelpers('bankDetails.accountName')} fieldMeta={sellerForm.getFieldMeta('bankDetails.accountName')} edit={true} dataLoaded={true} />
                            <FieldInput label={'Account No'} placeholder={'Account No'} fieldProps={sellerForm.getFieldProps('bankDetails.accountNo')} fieldHelper={sellerForm.getFieldHelpers('bankDetails.accountNo')} fieldMeta={sellerForm.getFieldMeta('bankDetails.accountNo')} edit={true} dataLoaded={true} />
                            <FieldInput label={'IFSC Code'} placeholder={'IFSC Code'} fieldProps={sellerForm.getFieldProps('bankDetails.ifscCode')} fieldHelper={sellerForm.getFieldHelpers('bankDetails.ifscCode')} fieldMeta={sellerForm.getFieldMeta('bankDetails.ifscCode')} edit={true} dataLoaded={true} />
                            <FieldInput label={'Branch Name'} placeholder={'Branch Name'} fieldProps={sellerForm.getFieldProps('bankDetails.branchName')} fieldHelper={sellerForm.getFieldHelpers('bankDetails.branchName')} fieldMeta={sellerForm.getFieldMeta('bankDetails.branchName')} edit={true} dataLoaded={true} />
                        </motion.div>
                        <motion.div className='flex w-full my-2  px-5'>
                            <p className='font-bold text-xl'>Firm Address</p>
                            <div></div>
                        </motion.div>
                        <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                            <FieldInput label={'Pincode'} placeholder={'Pincode'} fieldProps={sellerForm.getFieldProps('accountAddress.pinCode')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.pinCode')} fieldMeta={sellerForm.getFieldMeta('accountAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                            <FieldInput label={'Address Line 1'} placeholder={'Address Line 1'} fieldProps={sellerForm.getFieldProps('accountAddress.addressLine1')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.addressLine1')} fieldMeta={sellerForm.getFieldMeta('accountAddress.addressLine1')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'Address Line 2'} placeholder={'Address Line 2'} fieldProps={sellerForm.getFieldProps('accountAddress.addressLine2')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.addressLine2')} fieldMeta={sellerForm.getFieldMeta('accountAddress.addressLine2')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'City'} placeholder={'City'} fieldProps={sellerForm.getFieldProps('accountAddress.city')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.city')} fieldMeta={sellerForm.getFieldMeta('accountAddress.city')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'District'} placeholder={'District'} fieldProps={sellerForm.getFieldProps('accountAddress.district')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.district')} fieldMeta={sellerForm.getFieldMeta('accountAddress.district')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'Landmark'} placeholder={'Landmark'} fieldProps={sellerForm.getFieldProps('accountAddress.landMark')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.landMark')} fieldMeta={sellerForm.getFieldMeta('accountAddress.landMark')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'State'} placeholder={'State'} fieldProps={sellerForm.getFieldProps('accountAddress.state')} fieldHelper={sellerForm.getFieldHelpers('accountAddress.state')} fieldMeta={sellerForm.getFieldMeta('accountAddress.state')} edit={addressEdit} dataLoaded={true} />
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-row w-full items-center justify-center">
                        <Button injectClass={`ring-1 ring-[black] rounded-full hover:bg-primeColor/10 ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => !submitDisabled && sellerForm.submitForm()}>{t('Create Account')}</Button>
                    </motion.div>
                </motion.div> : alreadyRegister.status === 'Pending' && <motion.div className="h-full w-full flex flex-col justify-center items-center">
                    <motion.div clasName="h-full w-full">
                        <img src={verification} height={500} width={500} alt="verification" />
                    </motion.div>
                    <motion.div className="text-xl font-bold">
                        Your store is under verification
                    </motion.div>
                </motion.div>
            }
        </>
    )
}

export default CreateSellerAccount